import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Components

// Lib MISC
import { useMultiHyphenText } from '@/computedValues/useMultiHyphenText'
import styles from './style.scss'

gsap.registerPlugin(ScrollTrigger)

const cx = classnames.bind(styles)

export const propTypes = {
  image: PropTypes.node,
  title: PropTypes.string,
  item: PropTypes.array,
  hasDot: PropTypes.bool,
  index: PropTypes.number,
}

function SolutionItem(props) {
  const { image, title, item, hasDot, index: itemIndex } = props

  const isOddRow = itemIndex % 2 === 0

  const { computedTitle } = useMultiHyphenText(title)

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.fade-wrapper-${itemIndex}`,
      },
    })
    tl.set(`.fade-item-${itemIndex}`, { opacity: 0, x: -28 })
    tl.to(`.fade-item-${itemIndex}`, { opacity: 1, x: 0, stagger: 0.1 })
    return () => {
      tl.kill()
    }
  }, [itemIndex])

  return (
    <div className={cx('solution-item')} data-is-odd={isOddRow}>
      <div className={cx('solution-item__content', `fade-wrapper-${itemIndex}`)}>
        <div className={cx('solution-item__content-title', `fade-item-${itemIndex}`)}>
          {computedTitle.map((title, index) => (
            <p className={cx('solution-item__content-title-text')} key={index}>
              {title}
            </p>
          ))}
        </div>
        {item.map((item, index) => {
          return (
            <div key={index} className={cx('solution-item__content-item', `fade-item-${itemIndex}`)}>
              {hasDot && (
                <div className={cx('solution-item__content-item-dot')}>
                  <div className={cx('solution-item__content-item-dot-circle')} />
                </div>
              )}
              <p className={cx('solution-item__content-item-text')}>{item}</p>
            </div>
          )
        })}
      </div>
      <div className={cx('solution-item__image')}>
        <img className={cx('solution-item__image-item')} src={image} alt={title} />
      </div>
    </div>
  )
}

SolutionItem.propTypes = propTypes

export default SolutionItem
